import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ReleaseType } from '../types';
import { FilterButtons } from '../FilterButtons';
import { RELEASE } from '../../constants';
function getCountGamesByReleaseType(games, element) {
    const releaseCounts = games.reduce((counts, item) => {
        if (!element.querySelector(`[data-sku="${item.sku}"]`)) {
            return counts;
        }
        const releaseAttribute = item.attributes.find((attr) => attr.name.toLowerCase() === RELEASE);
        if (releaseAttribute) {
            releaseAttribute.values.forEach(({ value }) => {
                counts[value] = !counts[value] ? 1 : counts[value] + 1;
            });
        }
        return counts;
    }, {});
    return releaseCounts;
}
export const ReleaseFilter = ({ onReleaseTypeChange, selectedReleaseType, state, element, }) => {
    const [countReleaseType, setGamesCountByReleaseType] = useState();
    const buttons = [
        {
            name: 'All',
            value: ReleaseType.All,
            onClick: () => {
                onReleaseTypeChange(ReleaseType.All);
            },
        },
        {
            name: `Released - ${countReleaseType?.released ?? 0}`,
            value: ReleaseType.Released,
            onClick: () => {
                onReleaseTypeChange(ReleaseType.Released);
            },
        },
        {
            name: `Coming Soon - ${countReleaseType?.[ReleaseType.ComingSoon] ?? 0}`,
            value: ReleaseType.ComingSoon,
            onClick: () => {
                onReleaseTypeChange(ReleaseType.ComingSoon);
            },
        }
    ];
    useEffect(() => {
        setGamesCountByReleaseType(getCountGamesByReleaseType(state.storeState.units.items, element));
    }, []);
    return _jsx(FilterButtons, { buttons: buttons, selectedValue: selectedReleaseType, name: "By Release" });
};
